export default {
  TOKEN_LABEL: 'auth_token',
};
